import SlotsHistoryPage from './SlotsHistoryPage';

export default SlotsHistoryPage;